/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { EXPENSE_TYPES_OPTIONS } from 'domain/shared/expense';

const ExpenseTypeField = (props: FieldProps) => {
  return <EnumField options={EXPENSE_TYPES_OPTIONS} {...props} />;
};

export default ExpenseTypeField;
